const o = "_baseStyle_rml47_1", n = "_dot_rml47_10", t = "_brand_rml47_20", _ = "_gray_rml47_24", l = "_oval_rml47_28", r = "_onTopOfComponent_rml47_34", e = "_withChildrenContainer_rml47_44", a = {
  baseStyle: o,
  dot: n,
  default: "_default_rml47_15",
  brand: t,
  gray: _,
  oval: l,
  onTopOfComponent: r,
  withChildrenContainer: e
};
export {
  o as baseStyle,
  t as brand,
  a as default,
  n as dot,
  _ as gray,
  r as onTopOfComponent,
  l as oval,
  e as withChildrenContainer
};
//# sourceMappingURL=index.es587.js.map
